/** Affiche un texte assistant sans markdown brut (**bold**, etc.). */
export function formatAssistantText(text) {
  if (!text) return '';
  return String(text)
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/^#{1,3}\s+/gm, '')
    .replace(/^[•\-]\s+/gm, '• ');
}

export const WHATSAPP_AGENT_E164 = '224663078268';
export const WHATSAPP_AGENT_DISPLAY = '+224 663 07 82 68';

export function buildAgentWhatsAppUrl(userQuestion, language = 'fr') {
  const q = String(userQuestion || '').trim().slice(0, 800);
  const body =
    language === 'en'
      ? `Hello, I am a Conakry en Poche client.\n\nMy question:\n${q || '(no question provided)'}\n\nPlease help me. Thank you.`
      : `Bonjour, je suis un client Conakry en Poche.\n\nMa question :\n${q || '(non précisée)'}\n\nMerci de m’aider.`;
  return `https://wa.me/${WHATSAPP_AGENT_E164}?text=${encodeURIComponent(body)}`;
}
